'use client';

import { MagnifyingGlassXs } from '@lichtblick/photon/icons/objects/magnifying-glass-xs';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import type { FC } from 'react';

import headerStyles from './header.module.scss';
import { MetaNavigationLink } from './meta-navigation-link';
import styles from './search-button.module.scss';

export const SearchField: FC = () => {
  const router = useRouter();

  return (
    <>
      <MetaNavigationLink className={classNames(headerStyles['search-link'], styles.link)} href="/suche/" label="Suche">
        <MagnifyingGlassXs />
      </MetaNavigationLink>
      <form
        action={(formData) => {
          const rawInputValue = formData.get('search') as string;

          // remove leading/trailing and double spaces
          const sanitizedInputValue = rawInputValue.trim().replace(/\s{2,}/g, ' ');

          router.push(`/suche/${encodeURIComponent(sanitizedInputValue)}/`);
        }}
        className={classNames(styles.container, headerStyles['search-link'])}
      >
        <input
          aria-label="Suche"
          autoComplete="off"
          className={styles.input}
          maxLength={80}
          minLength={3}
          name="search"
          onBlur={(e) => {
            e.currentTarget.value = '';
          }}
          onInvalid={(e) => {
            e.preventDefault();
          }}
          placeholder="Suche"
          type="search"
        />
        <MagnifyingGlassXs className={styles.icon} />
      </form>
    </>
  );
};
